import React, { Component, useEffect, useState, useRef } from 'react';
import config from '../../helpers/config';
import { connect } from 'react-redux';
import { fetchCore } from '../actions';
import Helmet from '../components/Helmet';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';

import { PageCover, Logo, Separator, LogoBanner, Container } from  '../components';
import hash from '../../helpers/hash';
import { useParams, NavLink } from 'react-router-dom';
import MainContent from '../components/core/MainContent';
import useDeepCompareEffect from 'use-deep-compare-effect'

const useStyles = makeStyles(theme => ({

    contentCover: props => ({
        height: 'calc(100vh - 75px)',
        minHeight: 900,
        position: "relative",

        "& > div": {    
            backgroundImage: `url(${config.S3Endpoint}${hash.walk('content.bg', props)})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            left: 0,
            height: '100%',
            width: '100%'
        },

        "& h4": {
            lineHeight: '2em'
        },

        "& img": {
            height: 447,
            width: 518,
            transform: 'scale(0.5)',
            [theme.breakpoints.down("md")]: {
                transform: 'scale(0.4)',
            },
            [theme.breakpoints.down("sm")]: {
                transform: 'scale(0.25)',
            },
            [theme.breakpoints.down("xs")]: {
                display: 'none'
            }
        }
    }), 

    switchButtonBar: {
        textAlign: 'center',
        margin: '100px 0',
        [theme.breakpoints.down("md")]: {
            margin: '75px 0',
        },
        [theme.breakpoints.down("sm")]: {
            margin: '50px 0',
        },
        [theme.breakpoints.down("xs")]: {
            margin: '25px 0',
        }
    },

    switchButton: props => ({
        display: 'inline-block',
        padding: '10px 50px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '25px',
        textDecoration: 'none',

        [theme.breakpoints.down("xs")]: {
           padding: '10px 25px', 
        }, 

        '&.monitor': {
            color: hash.walk('theme.secondary', props),
            '&.selected': {
                color: "white",
                backgroundColor: hash.walk('theme.secondary', props),
            }
        },
        '&.visit': {
            color: hash.walk('theme.primary', props),
            '&.selected': {
                color: "white",
                backgroundColor: hash.walk('theme.primary', props),
            }
        },
        '&.breastfeed': {
            color: hash.walk('theme.secondary', props),
            '&.selected': {
                color: "white",
                backgroundColor: hash.walk('theme.secondary', props),
            }
        }
    }),  
}));

const CorePage = (props) => {

    const theme = useTheme();
    const [id, setId] = useState(useParams().id);
    const contentRef = useRef(null);

    useEffect(() => {
        console.log(id)
        if (id === "monitor" || id === "visit" || id === "breastfeed") {
            props.core.skipScroll = true;
            contentRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
    }, [id]);


    const { core } = props;
    const classes = useStyles(core);
    
    useDeepCompareEffect(() => {
        if (!core.isLoaded) props.fetchCore();
    }, [core])

    if (!core.isLoaded) {
        return <div>Loading...</div>;
    }

    const PageCoverProps = {
        ...core,
        style: {
            height: 'calc(100vh - 75px)',
            title: {
                position: 'absolute',
                top: 'auto',
                right: '0',
                bottom: '10%',
                left: 'auto',
                width: '33%',
                letterSpacing: '10px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: 'white',
                fontWeight: '500',
                padding: '20px 0px 20px 5vw',
                borderTopLeftRadius: '40px',
                borderBottomLeftRadius: '40px',
                border: '1px solid #dadada',
                textShadow: '1px 1px 4px black',
                '& h1': {
                    float: 'left',
                    fontWeight: '500'
                },
                [theme.breakpoints.down('xs')] : {
                    width: '75%',
                }
            }
        }
    };
    
    return (
        <div className={classes.container}>
            <Helmet {...core} />
            <div>
                <PageCover {...PageCoverProps} > 
                    <Typography variant="h1">{core.name}</Typography>
                </PageCover>

                <div className={classes.contentCover}>
                    <div></div>
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={1} sm={1} md={1} lg={1}></Grid>
                        <Grid item xs={9} sm={5} md={5} lg={5}>
                            {hash.walk("content.items", core) && core.content.items.map((d, i) => {
                                return d === " " ? <Typography variant="h4" key={i}>&nbsp;</Typography> : <Typography variant="h4" key={i}>{d}</Typography>
                            })}
                        </Grid>
                        <Grid item xs={1} sm={3} md={3} lg={3}>
                            <img src={config.S3Endpoint + hash.walk("content.logo", core)}/>
                        </Grid>
                        <Grid item xs={1} sm={2} md={2} lg={2}></Grid>
                    </Grid>
                </div>
            
                <Container>
                    <div className={classes.switchButtonBar}>
                        <NavLink to="/core/monitor" className={classes.switchButton + ' monitor ' + ((id !== 'visit' && id !== 'breastfeed') ? 'selected' : '')} onClick={() => setId("monitor")} activeClassName="selected">
                            <Typography variant="h3"><b>感控原則</b></Typography>
                        </NavLink>
                        <Separator vertical width="15%" />
                        <NavLink to="/core/visit" className={classes.switchButton + ' visit ' + ((id !== 'monitor' && id !== 'breastfeed') ? 'selected' : '')} onClick={() => setId("visit")} activeClassName="selected">
                            <Typography variant="h3"><b>參訪原則</b></Typography>
                        </NavLink>
                        <Separator vertical width="15%" />
                        <NavLink to="/core/breastfeed" className={classes.switchButton + ' breastfeed ' + ((id !== 'visit' && id !== 'monitor') ? 'selected' : '')} onClick={() => setId("breastfeed")} activeClassName="selected">
                            <Typography variant="h3"><b>母乳支持政策說明</b></Typography>
                        </NavLink>

                    </div>
                </Container>

                <div ref={contentRef}>
                    <MainContent {...core[id || "monitor"]} />
                </div>

            </div>
        </div>
    )
}

function mapStateToProps({ core }) {
    return { core };
}

export default {
    loadData: ({ dispatch }) => dispatch(fetchCore()),
    component:  connect(mapStateToProps, { fetchCore }) (CorePage)
}



// WEBPACK FOOTER //
// ./src/client/pages/CorePage.js